import { STARTER_DASHBOARD_ROUTE_ELEMENTS } from '@/soluqr/tiers/starter/dashboardRoutes';
import { PRO_DASHBOARD_ROUTE_ELEMENTS } from '@/soluqr/tiers/pro/dashboardRoutes';
import { BUSINESS_DASHBOARD_ROUTE_ELEMENTS } from '@/soluqr/tiers/business/dashboardRoutes';

/** Rutas hijas de /dashboard (segment + element). */
export const DASHBOARD_ROUTE_ELEMENTS = [
  ...STARTER_DASHBOARD_ROUTE_ELEMENTS,
  ...PRO_DASHBOARD_ROUTE_ELEMENTS,
  ...BUSINESS_DASHBOARD_ROUTE_ELEMENTS,
];
